export type ApartmentType =
  | 'Bilocale'
  | 'Trilocale'
  | 'Monolocale'
  | 'Loft'
  | 'Attico'
export interface ApartmentContract {
  active: boolean
  plan: string
  expiry: string
  pricePerClean: number
}
export interface ApartmentIntervention {
  id: string
  date: string
  type: string
  cleaner: string
  score: number | null
  status: 'Completata' | 'Pianificata' | 'In corso'
  earning: number
}
export interface Apartment {
  id: string
  name: string
  address: string
  zone: string
  type: ApartmentType
  cover: string
  referente: string
  // Map coordinates (percent 0-100 within the decorative map)
  mapX: number
  mapY: number
  contract: ApartmentContract | null
  cleaningsDone: number
  cleaningsTotal: number
  interventions: ApartmentIntervention[]
}
export const TYPE_STYLE: Record<ApartmentType, string> = {
  Bilocale: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Trilocale: 'bg-navy/5 text-navy border-navy/20',
  Monolocale: 'bg-amber-50 text-amber-700 border-amber-200',
  Loft: 'bg-coral/5 text-coral border-coral/30',
  Attico: 'bg-purple-50 text-purple-700 border-purple-200',
}
export const APARTMENTS: Apartment[] = [
  {
    id: 'a1',
    name: 'Loft Navigli',
    address: 'Via Vigevano 18',
    zone: 'Milano · Navigli',
    type: 'Loft',
    cover:
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&q=80&w=400',
    referente: 'Marco Rossi',
    mapX: 34,
    mapY: 62,
    contract: {
      active: true,
      plan: 'Turnover · 20 pulizie',
      expiry: '30 Giu 2024',
      pricePerClean: 45,
    },
    cleaningsDone: 13,
    cleaningsTotal: 20,
    interventions: [
      {
        id: 'i1',
        date: '15 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Francesca N.',
        score: 96,
        status: 'Completata',
        earning: 45,
      },
      {
        id: 'i2',
        date: '8 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Francesca N.',
        score: 92,
        status: 'Completata',
        earning: 45,
      },
      {
        id: 'i3',
        date: '2 Gen 2024',
        type: 'Deep cleaning',
        cleaner: 'Luca B.',
        score: 88,
        status: 'Completata',
        earning: 80,
      },
      {
        id: 'i4',
        date: '27 Dic 2023',
        type: 'Pulizia turnover',
        cleaner: 'Sara M.',
        score: 94,
        status: 'Completata',
        earning: 45,
      },
      {
        id: 'i5',
        date: '20 Dic 2023',
        type: 'Pulizia turnover',
        cleaner: 'Francesca N.',
        score: 90,
        status: 'Completata',
        earning: 45,
      },
    ],
  },
  {
    id: 'a2',
    name: 'Bilo Porta Romana',
    address: 'Viale Sabotino 4',
    zone: 'Milano · Porta Romana',
    type: 'Bilocale',
    cover:
      'https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&q=80&w=400',
    referente: 'Elena Colombo',
    mapX: 66,
    mapY: 70,
    contract: {
      active: true,
      plan: 'Turnover · 15 pulizie',
      expiry: '15 Mag 2024',
      pricePerClean: 42,
    },
    cleaningsDone: 9,
    cleaningsTotal: 15,
    interventions: [
      {
        id: 'i1',
        date: '14 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Luca B.',
        score: 91,
        status: 'Completata',
        earning: 42,
      },
      {
        id: 'i2',
        date: '6 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Luca B.',
        score: 85,
        status: 'Completata',
        earning: 42,
      },
      {
        id: 'i3',
        date: '29 Dic 2023',
        type: 'Pulizia turnover',
        cleaner: 'Sara M.',
        score: 89,
        status: 'Completata',
        earning: 42,
      },
    ],
  },
  {
    id: 'a3',
    name: 'Studio Isola',
    address: 'Via Borsieri 5',
    zone: 'Milano · Isola',
    type: 'Monolocale',
    cover:
      'https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&q=80&w=400',
    referente: 'Laura Bianchi',
    mapX: 72,
    mapY: 26,
    contract: {
      active: true,
      plan: 'Turnover · 10 pulizie',
      expiry: '20 Apr 2024',
      pricePerClean: 40,
    },
    cleaningsDone: 7,
    cleaningsTotal: 10,
    interventions: [
      {
        id: 'i1',
        date: '12 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Sara M.',
        score: 97,
        status: 'Completata',
        earning: 40,
      },
      {
        id: 'i2',
        date: '4 Gen 2024',
        type: 'Pulizia turnover',
        cleaner: 'Sara M.',
        score: 93,
        status: 'Completata',
        earning: 40,
      },
    ],
  },
  {
    id: 'a4',
    name: 'Trilo Centro',
    address: 'Via Dante 12',
    zone: 'Milano · Centro',
    type: 'Trilocale',
    cover:
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&q=80&w=400',
    referente: 'Giuseppe Verdi',
    mapX: 58,
    mapY: 36,
    contract: null,
    cleaningsDone: 0,
    cleaningsTotal: 0,
    interventions: [],
  },
  {
    id: 'a5',
    name: 'Attico Tortona',
    address: 'Via Tortona 27',
    zone: 'Milano · Tortona',
    type: 'Attico',
    cover:
      'https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?auto=format&fit=crop&q=80&w=400',
    referente: 'Sophie Laurent',
    mapX: 28,
    mapY: 48,
    contract: {
      active: true,
      plan: 'Deep cleaning · 8 pulizie',
      expiry: '10 Lug 2024',
      pricePerClean: 80,
    },
    cleaningsDone: 2,
    cleaningsTotal: 8,
    interventions: [
      {
        id: 'i1',
        date: '13 Gen 2024',
        type: 'Deep cleaning',
        cleaner: 'Luca B.',
        score: 99,
        status: 'Completata',
        earning: 80,
      },
      {
        id: 'i2',
        date: '30 Dic 2023',
        type: 'Deep cleaning',
        cleaner: 'Francesca N.',
        score: 95,
        status: 'Completata',
        earning: 80,
      },
    ],
  },
]
export function getApartmentById(
  id: string | undefined,
): Apartment | undefined {
  return APARTMENTS.find((a) => a.id === id)
}
export function scoreColor(score: number): string {
  if (score >= 95) return 'bg-emerald-50 text-emerald-700 border-emerald-200'
  if (score >= 88) return 'bg-teal-deep/10 text-teal-deep border-teal-deep/20'
  if (score >= 80) return 'bg-amber-50 text-amber-700 border-amber-200'
  return 'bg-red-50 text-red-600 border-red-200'
}
// House specifications the Host fills in (Accesso, Preferenze, Punti di
// attenzione) — surfaced read-only to the Cleaner Manager so the team knows
// how to enter and how the host wants the place cleaned.
export interface ApartmentSpecs {
  access: {
    type: string // e.g. 'Codice tastierino', 'Key box', 'Portiere'
    code?: string
    notes?: string
  }
  preferences: {
    desiderata: string[] // host wishes that must always be respected
    favProducts: string[]
  }
  attention: {
    delicateMaterials: string[]
    materialNote?: string
    avoidProducts: string[]
  }
}
const DEFAULT_SPECS: ApartmentSpecs = {
  access: {
    type: 'Codice tastierino',
    code: '1234 #',
    notes: 'Il tastierino si trova sulla sinistra del portone.',
  },
  preferences: {
    desiderata: [
      'Lenzuola sempre stirate',
      'Cuscini divano sistemati in modo specifico',
      'Lasciare luci ingresso accese',
    ],
    favProducts: ['Detergente Bio', 'Anticalcare X', 'Sgrassatore Limone'],
  },
  attention: {
    delicateMaterials: ['Parquet antico', 'Marmo Carrara', 'Tessuti delicati'],
    materialNote:
      'Il parquet in salotto è molto delicato: usare solo prodotti specifici e panno ben strizzato.',
    avoidProducts: ['Candeggina', 'Ammoniaca'],
  },
}
const SPECS_BY_ID: Record<string, ApartmentSpecs> = {
  a1: DEFAULT_SPECS,
  a2: {
    access: {
      type: 'Key box',
      code: '0815',
      notes: 'Key box accanto al citofono, codice a 4 cifre.',
    },
    preferences: {
      desiderata: [
        'Asciugamani piegati a cigno',
        'Caffè in cialde lasciato pronto',
      ],
      favProducts: ['Detergente neutro', 'Spray multiuso'],
    },
    attention: {
      delicateMaterials: ['Piano cucina in quarzo'],
      materialNote: 'Evitare spugne abrasive sul piano cucina.',
      avoidProducts: ['Candeggina'],
    },
  },
  a5: {
    access: {
      type: 'Portiere',
      notes:
        'Ritirare le chiavi dal portiere (Sig. Bianchi) negli orari 8:00–18:00.',
    },
    preferences: {
      desiderata: [
        'Tende sempre aperte dopo la pulizia',
        'Profumatore ambiente in ingresso',
      ],
      favProducts: ['Linea bio premium'],
    },
    attention: {
      delicateMaterials: ['Vetrate panoramiche', 'Parquet rovere'],
      materialNote:
        'Vetrate: usare solo panno in microfibra, niente raschietti.',
      avoidProducts: ['Ammoniaca', 'Prodotti profumati aggressivi'],
    },
  },
}
export function getApartmentSpecs(id: string | undefined): ApartmentSpecs {
  return (id && SPECS_BY_ID[id]) || DEFAULT_SPECS
}
